import CheckIcon from "@/assets/icons/check-small.svg";
import React from "react";

const IconCheck = (props: React.ComponentProps<"svg">) => (
  <CheckIcon {...props} />
);

export default IconCheck; 